
































import dayjs from 'dayjs';
import { defineComponent, onMounted, computed, watch, onUnmounted, getCurrentInstance } from '@vue/composition-api';
import Cookies from 'js-cookie';
import _ from 'lodash';

// 引入vue
import winBar from '@/renderer/views/common/winBar.vue';
import Updater from '@/renderer/views/common/Updater.vue';
import HotkeyDrawer from '@/renderer/components/drawer/Hotkey/HotkeyDrawer.vue';
import CoSyncFileConflictNotification from '@/renderer/components/SyncFile/CoSyncFileConflictNotification.vue';

// 引入 compositions
import rendererHandler from '@/renderer/views/desktop/headbar/composition/generalRendererHandler';

// 引入工具类
import { closeDialog as closeSwitchMobileStyleDialog } from '@/renderer/scripts/composition/dialogHandler';
import { WEBCONTENTS_READY_FOR_IPC_SIGNAL, IpcEvents } from '@/ipc-events';
import store from '@/renderer/store';
import ipc from '@/renderer/scripts/utils/ipc';
import user from '@/renderer/scripts/utils/user';
import { checkTransBeforeQuit } from '@/renderer/scripts/utils/transmission/helper';
import downloadCodeHandler from '@/renderer/scripts/composition/downloadCode';
import {
  isAllowImageMogr,
  isAllowPreviewVideo,
  isAllowEditDoc,
  isAllowEsign,
} from '@/renderer/scripts/composition/allowPreview';
import meeting from '@/renderer/scripts/utils/meeting';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import spaceATM from '@/renderer/scripts/utils/AccessTokenManager/space';
import tips from '@/renderer/scripts/utils/tips';
import smh from '@/renderer/scripts/smh';
import { getUrlQuery } from '@/renderer/scripts/utils/tools/index';
import { NotificationsCLickInfo, NotificationsType, SysNotificationsEevnet } from '@/common/SysNotificationsDataDefine';
import { DrawerEvents } from '@/renderer/store/modules/drawer';
import i18n, { i18n_t } from '@/locales/i18n';
import { IS_BROWSER, IS_PC } from '@/common/constant/platform';
import storage from '@/renderer/scripts/utils/storage';
import transmissionDBManager from '@/renderer/scripts/utils/TransmissionDBManager';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import { windowEnvs } from '@/renderer/scripts/utils/ConstantConfig/PrivateConfig';
import { manageConsoleRouters } from '@/renderer/router';

import vistor from './scripts/utils/vistor';
import sysNotifications from './scripts/utils/SysNotifications';

function mobileStyleChangeHandler(vm: Vue) {
  const { isBrowser, isMobile } = vm.$store.getters;
  // FIX：windows的会议里出现拖拽到604px不能再往小拖动问题，这里移动端尺寸判断从600调至620
  const mobileWidth = 620;
  if (isBrowser || isMobile) {
    store.commit('setMobileStyle', (document.body.clientWidth <= mobileWidth && isBrowser) || isMobile);
  }
  // 监听应用窗口大小改变 （pc端on不到,有刷新可以）
  window.onresize = (e: Event) => {
    if (window.innerWidth < 1050) {
      store.commit(DrawerEvents.TOGGLE_DRAWER, false);
    } else {
      store.commit(DrawerEvents.TOGGLE_DRAWER, true);
    }
    const { innerHeight: height, innerWidth: width } = e.target as Window;
    const size = {
      height,
      width,
    };
    ipc.emit(ipc.RENDERER_EVENTS_MAP.WIN_RESIZE, size);
    if (width <= mobileWidth && isBrowser) {
      store.commit('setMobileStyle', true);
    } else {
      store.commit('setMobileStyle', false);
      closeSwitchMobileStyleDialog();
    }
  };
  vm.$store.getters.isInWeMeetApp &&
    meeting.SDK.addEventListener('sidebar-position-changed', (event: any) => {
      // 记录窗口位置
      meeting.setWemeetAppPosition(event.position);
      if (event.position === 2) {
        store.commit('setMobileStyle', true);
      } else {
        store.commit('setMobileStyle', false);
        closeSwitchMobileStyleDialog();
      }
    });
}
dayjs.locale(i18n.locale);
export default defineComponent({
  components: { winBar, Updater, HotkeyDrawer, CoSyncFileConflictNotification },
  setup(props, context) {
    const { methods: headBarMethods } = rendererHandler();
    const vm = getCurrentInstance()?.proxy || context.root;
    const { isBrowser } = vm.$store.getters;
    const isLoginRoute = computed(() => vm.$route.meta?.isLoginPage || vm.$route.name === 'login');
    const { showAnnouncements = false } = windowEnvs;
    // 获取公告（交大使用）
    if (showAnnouncements) {
      store.dispatch('getAnnouncements');
    }

    const isWechatLogining = () => {
      const { href } = window.location;
      const { query } = getUrlQuery(href);
      const { path = '', code = '', state = '' } = query;
      if (path === '/login' && code && typeof state === 'string' && state.startsWith('wxlogin_')) {
        return true;
      }
      return false;
    };
    watch(
      () => store.getters.userRole,
      val => {
        user.setUserRole(val);
      },
    );
    watch(
      () => store.getters.orgExpired,
      newVal => {
        const { pathname } = window.location;
        const forbidRouteNameList = ['teamExpired', 'invitation'];
        const canChangeRoute =
          !forbidRouteNameList.includes(vm.$route.name as string) &&
          !forbidRouteNameList.some(item => pathname.includes(`web/${item}`));

        if (newVal && canChangeRoute && vm.$store.getters.isLogined) {
          dispatchRouter({
            name: 'teamExpired',
          });
          tips.closeAll();
        }
      },
    );
    smh.on('org-expired', () => {
      if (!store.getters.orgExpired) {
        user.setOrgExpired(true);
      }
    });
    if (vm.$store.getters.isInWeMeetApp) {
      // 进入预览/编辑时隐藏腾讯会议的分享入口
      watch(
        () => vm.$route,
        val => {
          if (['doc', 'media', 'edit'].includes(val.name as string)) {
            // 进入预览/编辑时隐藏腾讯会议的分享入口
            meeting.setShareOpenAppConfig({
              shareEnable: false,
            });
          } else {
            // 离开则将分享icon展示
            meeting.resetShare();
          }
        },
      );
      // 会议里给body加个class
      document.body.className += 'wemeet';
    }
    const { methods: downloadCodeMethods } = downloadCodeHandler();
    mobileStyleChangeHandler(vm);

    // 每半小时向灯塔发送一次心跳事件
    const reporterHeartBeat = () => {
      window.setInterval(() => {
        reporter.report('tcd_heart_beat', {});
      }, 60 * 30 * 1000);
    };
    const popupDlgInfoList = [
      {
        Id: 'trans',
        event: 'webTransShow',
      },
      {
        Id: 'noticeCenter',
        event: 'noticeCenterShow',
      },
    ];
    const closePopupDlg = (e: MouseEvent) => {
      popupDlgInfoList.forEach(dlgInfo => {
        const { Id, event } = dlgInfo;
        const dlgDom = document.getElementById(Id);
        if (dlgDom && !dlgDom.contains(e.target as any)) {
          const dlgRect = dlgDom.getBoundingClientRect();
          if (
            e.clientX < dlgRect?.left ||
            e.clientX > dlgRect?.right ||
            e.clientY < dlgRect?.top ||
            e.clientY > dlgRect?.bottom
          ) {
            ipc.emit(event, {
              show: false,
            });
          }
        }
      });
    };
    document.addEventListener('click', closePopupDlg);
    const CloseAllPopupDlg = _.throttle(() => {
      popupDlgInfoList.forEach(dlgInfo => {
        const { event } = dlgInfo;
        ipc.emit(event, {
          show: false,
        });
      });
    }, 1000);
    window.addEventListener('resize', CloseAllPopupDlg);
    // 初始化用户数据
    const initData = async () => {
      user.setRouteFn(dispatchRouter);
      // 解耦user和store，将store和spaceATM注入user
      user.setStoreFn(store);
      user.setSpaceATMFn(spaceATM);
      if (meeting.isTMWebview) {
        // 由于会议移动端的 title 会议侧无法设置，因此项目内自行修改应用名。
        document.title = i18n_t('会议文件空间');
        return;
      }
      // 微信登录时会重定向一次，不用走这里恢复登录的逻辑 TODO 企微登录待观察
      if (isWechatLogining()) return;
      user.resetUserInfoFromLogin();
      // 只支持账号密码登录时不需要自动登录游客
      if (vm.$store.getters.onlyPasswordLogin) return;
      // 将store注入vistor中
      vistor.setStoreFn(store);
      vistor.resetVistorInfoFromLogin();
    };
    initData();
    reporterHeartBeat();
    const methods = {
      handleNotificationsCLick() {
        sysNotifications.on(SysNotificationsEevnet.EVENT_CLICK, (info: NotificationsCLickInfo) => {
          if (info.type !== NotificationsType.TYPE_WSMSG) {
            return;
          }
          logger.ui.info('clickNotifications TYPE_WSMSG', info);
          const routeName = vm.$route.name;
          const isConsoleRoute = manageConsoleRouters.find(item => item.name === routeName);
          if (isConsoleRoute) {
            // 在管理后台时 需跳回工作台
            dispatchRouter({ name: 'workbench' });
          }
          headBarMethods.showNotice();
          ipc.send(IpcEvents.WINDOW_SHOW);
        });
      },
    };
    if (!isBrowser) {
      // 通知主进程当前界面可以进行 ipc 通信
      ipc.ipcRenderer.send(WEBCONTENTS_READY_FOR_IPC_SIGNAL);
      ipc.ipcRenderer.on(IpcEvents.DOWNLOAD_CODE, (event, message) => {
        downloadCodeMethods.getCodeInfo(message as string);
      });
      sysNotifications.init();
      methods.handleNotificationsCLick();
    } else {
      // 监听其他窗口通信
      !vm.$store.getters.isInWeMeetApp &&
        window.addEventListener('storage', async (e: StorageEvent) => {
          const key = e.key?.toLowerCase();
          if (key === 'login' || key === 'vistor_login') {
            // 监听登入登出
            let newValue = {
              isLogined: false,
            };
            let oldValue = {
              isLogined: false,
            };
            try {
              newValue = JSON.parse(e.newValue as string);
            } catch (e) {
              newValue = {
                isLogined: false,
              };
            }
            try {
              oldValue = JSON.parse(e.oldValue as string);
            } catch (e) {
              oldValue = {
                isLogined: false,
              };
            }
            if (newValue?.isLogined === oldValue?.isLogined) return;
            if (Cookies.get('USER_TOKEN')) {
              // doc: 当前页面未登录但是有usertoken则刷新页面获取登录信息
              window.location.reload();
            } else if (Cookies.get('VISTOR_USER_TOKEN')) {
              // 当前页面未登录但是有vistortoken则刷新(文件收集,分享外链相关的页面)
              const vistorPath = ['web/share', 'web/collect', '/web/preview/media', '/web/preview/doc'];
              const routePath = vm.$route.path;
              vistorPath.forEach(item => {
                if (routePath.indexOf(item) !== -1) {
                  window.location.reload();
                }
              });
            } else if (store.getters.isLogined) {
              /* i18n-ignore*/
              logger.ui('当前页面已登录但是无用户信息,退出到登录页');
              // doc: 当前页面已登录但是无用户信息
              user.signOut();
            } else if (store.getters.isVistorLogined) {
              /* i18n-ignore*/
              logger.ui('当前页面已登录但是无用户信息,退出到登录页');
              // doc: 当前页面已登录但是无用户信息
              vistor.onLogout();
            }
          } else if (key === 'org_info') {
            // 监听切换身份
            let newValue = {
              organizationId: -1,
              libraryId: '',
            };
            let oldValue = {
              organizationId: -1,
              libraryId: '',
            };
            try {
              newValue = JSON.parse(e.newValue as string);
            } catch (e) {
              newValue = {
                organizationId: -1,
                libraryId: '',
              };
            }
            try {
              oldValue = JSON.parse(e.oldValue as string);
            } catch (e) {
              oldValue = {
                organizationId: -1,
                libraryId: '',
              };
            }
            // 这里登录时也会触发org_info的change，此时需要走登录逻辑
            if (oldValue?.organizationId === -1 || newValue?.organizationId === -1) return;
            if (newValue?.organizationId !== oldValue?.organizationId) {
              /* i18n-ignore*/
              logger.ui('切换进企业', oldValue?.organizationId, '->', newValue?.organizationId);
              window.location.reload();
            }
          } else if (key === 'watermark_flag') {
            storage.del(storage.StoreKey.WATERMARK_FLAG);
            const { newValue } = e;
            if (newValue === 'Y') {
              // 修改水印时重新加载相关页面(预览文档、预览视频、分享外链页面)
              const previewPath = ['/web/preview/media', '/web/preview/doc'];
              const routePath = vm.$route.path;
              const { from, name } = vm.$route.query;
              if (routePath.indexOf('/web/share') !== -1) {
                window.location.reload();
              } else {
                previewPath.forEach(item => {
                  // 只刷新预览页面支持预览的视频或者文档
                  if (routePath.indexOf(item) !== -1) {
                    if (
                      isAllowImageMogr(name as string) ||
                      isAllowPreviewVideo(name as string) ||
                      isAllowEditDoc(name as string) ||
                      isAllowEsign(name as string)
                    ) {
                      window.location.reload();
                    }
                  }
                });
              }
            }
          } else if (key === 'language_setting') {
            // 多窗口监听语言设置，刷新页面
            window.location.reload();
          }
        });
    }
    smh.initGetInfoFunction({
      getUserInfo: async () => user.getUserInfo(),
    });
    smh.on('sign-out', () => {
      // 确定登录后才强退，避免登录时强退清空了userToken，用户取消注销后无法自动登录
      logger.ui('smh sign out', `isLogined=${store.getters.isLogined}`, `orgId=${store.getters.orgId}`);
      store.getters.isLogined && store.getters.orgId > 0 && user.forceSignOut();
    });
    document.onreadystatechange = () => {
      if (document.readyState === 'complete' && window.innerWidth < 1050) {
        store.commit(DrawerEvents.TOGGLE_DRAWER, false);
      }
    };
    onMounted(() => {
      // 英文态下添加全局'en-US'样式
      if (i18n.locale === 'en-US') {
        document.documentElement.classList.add('en-US');
      }
      document.title = i18n_t('腾讯云企业网盘');
      ipc.emit(ipc.RENDERER_EVENTS_MAP.WIN_RESIZE, {
        height: document.body.clientHeight,
        width: document.body.clientWidth,
      });
      store.dispatch('GET_REMOTE_CONFIG'); // 初始化远端服务器配置

      // 退出程序时，没有记住登录就退出用户登录
      const remember = computed(() => store.getters.remember);
      ipc.on(IpcEvents.SIGN_OUT, () => {
        if (remember.value) return;
        user.signOut(0);
      });
      // 退出程序时，查看是否有正在上传或者下载中的任务，如果有，需要提示用户是否真的退出
      ipc.on(IpcEvents.CONFIRM_TRANSMISSION_PROGRESS, () => {
        checkTransBeforeQuit({
          type: 'quit',
          foundRunningTaskFn: () => {
            transmissionDBManager.updateCacheImmediately();
            ipc.send(IpcEvents.WINDOW_SHOW);
          },
          confirmFn: () => {
            setTimeout(() => {
              ipc.send(IpcEvents.CONFIRM_QUIT);
              !remember.value && user.signOut();
            }, 50);
          },
          noRunningTaskFn: () => {
            ipc.send(IpcEvents.CONFIRM_QUIT);
            !remember.value && user.signOut();
          },
        });
      });
      // 浏览器&非私有化下才需查询自定义企业信息
      if (isBrowser && !store.getters.isPrivate) {
        store.dispatch('getOrgCustomPortal').then(() => {
          if (store.getters.customDomainInfo.isCustomDomain) {
            document.title = store.getters.customDomainInfo.title || i18n_t('企业网盘');
          }
        });
      }
    });
    onUnmounted(() => {
      document.removeEventListener('click', closePopupDlg);
      window.removeEventListener('resize', CloseAllPopupDlg);
    });
    return {
      isLoginRoute,
      platform: {
        isBrowser: IS_BROWSER,
        isPC: IS_PC,
      },
    };
  },
});
